import React, { useState } from "react";
import PopupWrapper from "./PopupWrapper";
import { Eye, EyeOff } from "lucide-react";

const PinPopup = ({ isOpen, onClose, error, content, onConfirm }) => {
  const [pin, setPin] = useState("");
  const [showPin, setShowPin] = useState(false);

  const togglePinVisibility = () => setShowPin(!showPin);

  const handleSubmit = (e) => {
    e.preventDefault();
    const value = e.target.value;
    onConfirm(value);
    setPin("");
  };

  const handleChange = (e) => {
    e.preventDefault();
    const value = e.target.value;
    if (value.length <= 4) {
      setPin(value);
    }
    if (value.length === 4) {
      handleSubmit(e);
    }
  };

  if (!isOpen) return null;

  return (
    <PopupWrapper isOpen={isOpen} onClose={onClose} isSmall={true}>
      <h4>{content}</h4>
      <hr />
      {/* PIN Form */}
      <form onSubmit={handleSubmit}>
        <div className="d-flex mb-4 justify-content-center position-relative">
          <label htmlFor="pin" className="pr-3 text-gray-700 mb-1 fs-5">
            Enter PIN
          </label>
          <input
            type={showPin ? "text" : "password"}
            id="pin"
            value={pin}
            onChange={handleChange}
            className={`col-sm-4 form-control ${pin ? "hidden-password" : ""}`}
            maxLength={4}
            autoFocus
            required
          />
          <span
            className="passwordToggle position-absolute"
            onClick={togglePinVisibility}
            style={{
              cursor: "pointer",
              right: "70px", // position icon to the right
              top: "50%",
              transform: "translateY(-40%)", // vertically center the icon
            }}
          >
            {showPin ? <EyeOff /> : <Eye />}
          </span>
        </div>

        {error && <p className="mt-2 text-danger">{error}</p>}

        {/* Footer */}
        <div className="d-flex justify-content-center gap-3 mt-3">
          <button type="button" onClick={onClose} className="cancel-btn">
            Cancel
          </button>
          <button type="submit" className="confirm-btn">
            Confirm
          </button>
        </div>
      </form>
    </PopupWrapper>
  );
};

export default PinPopup;
